import { render, staticRenderFns } from "./ResponseMedicalAdvice.vue?vue&type=template&id=19a968cd&scoped=true"
import script from "./ResponseMedicalAdvice.vue?vue&type=script&lang=js"
export * from "./ResponseMedicalAdvice.vue?vue&type=script&lang=js"
import style0 from "./ResponseMedicalAdvice.vue?vue&type=style&index=0&id=19a968cd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a968cd",
  null
  
)

export default component.exports